import { Observable } from '../shared/observable';

export interface Modal {
  id: number;
  title: string;
  content: string;
}

export class ModalService {
  private static modals: Modal[] = [];
  public static modals$ = new Observable([]);

  public static openModal(modal: Partial<Modal>) {
    this.modals.push({ id: this.modals.length, ...modal } as Modal);
    this.modals$.next(this.modals);
  }

  public static closeModal(id: number) {
    const idx = this.modals.findIndex(x => x.id === id);
    if (idx != -1) {
      this.modals.splice(idx, 1);
      this.modals$.next(this.modals);
    }
  }

  public static closeLast() {
    this.closeModal(this.modals.length - 1);
  }
}